module.exports = __webpack_public_path__ + "img/consultied_logo_new.2b31c1b5.svg";